// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-cae402ec] button#id_date_of_birth {\n  z-index: 10;\n  color: #fff;\n}\n[data-v-cae402ec] #id_date_of_birth__dialog_ {\n  top: -5px !important;\n  transform: translate3d(-271px, -324px, 0px) !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
